/**
 * Sport catalog — platform dimension (ADR-028 / ADR-032).
 * Playable sports register modules in `src/sports/registry.js`.
 */

export const SPORT_IDS = Object.freeze({
  BADMINTON: "badminton",
  TENNIS: "tennis",
  PICKLEBALL: "pickleball",
  TABLE_TENNIS: "table_tennis",
  SQUASH: "squash",
  PADEL: "padel",
});

/** @typedef {typeof SPORT_IDS[keyof typeof SPORT_IDS]} SportId */

export const DEFAULT_SPORT = SPORT_IDS.BADMINTON;

/**
 * @param {string | null | undefined} value
 * @returns {SportId}
 */
export function normalizeSportId(value) {
  const v = String(value || "")
    .trim()
    .toLowerCase();
  return Object.values(SPORT_IDS).includes(/** @type {SportId} */ (v))
    ? /** @type {SportId} */ (v)
    : DEFAULT_SPORT;
}
